// "Build your pack" mix-and-match selector (snippets/pack-builder.liquid) —
// used by Travel Wet Wipes and any future 2-design pack product that
// defines the same custom.pack_builder JSON metafield. Replaces the raw
// Mix-option radio cards assets/product-form.js would otherwise render:
// when this metafield is present, sections/main-product.liquid renders NO
// [data-option-position] inputs at all, so product-form.js's own variant-
// card resolution block naturally no-ops (optionInputs.length === 0), and
// product-form.js also skips its Apple Pay wiring entirely (guarded on
// [data-cart-items-json]) — this file owns Apple Pay here instead.
//
// Each design maps directly to a REAL, standalone product variant id (see
// custom.pack_builder's shape in snippets/pack-builder.liquid) — there is
// no native Shopify Bundle / variant-fixed-bundle mechanism involved (that
// architecture was removed 2026-08-15: Facebook & Instagram, TikTok, and
// Snapchat Ads all unconditionally reject bundle products). Add to Cart and
// Apple Pay both submit the two designs' current counts as separate real
// cart line items in one request — never a single resolved variant id.
// Increasing one design's mix stepper always borrows one unit from the
// other, so countA + countB === the shared QUANTITY stepper's displayed
// total at all times — there is no invalid/partial state.
//
// The shared QUANTITY stepper (snippets/quantity-selector.liquid) always
// moves in steps of the SMALLEST tier's size (minSize below), regardless of
// which tier is "active" — there is no persistent selected-tier state.
// Instead, tier-button active/disabled state is derived purely from the
// CURRENT displayed quantity every render (renderTierState): a tier button
// is active when quantity exactly equals its size, and both buttons go
// inert once quantity exceeds the largest tier's size, at which point the
// customer freely drives quantity + mix themselves (per merchant request,
// 2026-08-25 — "Essential 3 + Essential 3 should price like one Value 6").
//
// Pricing mirrors the REAL deployed Discount Function's greedy tier
// decomposition exactly (decomposeQuantity/computeFlatTotal below — see
// extensions/wet-wipes-pack-pricing/src/cart_lines_discounts_generate_run.js
// in the volume-pricing-discount app) so the on-page preview never shows a
// number the backend wouldn't actually charge: for any quantity, fill as
// many of the largest tier as possible, then the next, etc. — e.g. 9 pieces
// previews as 1 Value Pack (100) + 1 Essential Pack (60) = 160, not a naive
// per-tier or per-unit calculation. It is still a PREVIEW only: the 2 real
// variants' own per-unit price is what /cart/add.js itself charges until
// the Discount Function applies at checkout.
(function () {
  var root = document.querySelector('[data-pack-builder]');
  if (!root) return;

  var jsonEl = root.querySelector('[data-pack-builder-json]');
  var pb = null;
  try {
    pb = JSON.parse(jsonEl.textContent);
  } catch (e) {
    pb = null;
  }
  if (!pb || !pb.tiers || !pb.tiers.length || !pb.designs || pb.designs.length !== 2) return;
  if (!pb.designs[0].variant_id || !pb.designs[1].variant_id) return;

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantIdInput = form.querySelector('[data-variant-id]');
  var itemsJsonInput = form.querySelector('[data-cart-items-json]');
  var addToCartBtn = form.querySelector('[data-add-to-cart]');
  var applePayBtn = form.querySelector('[data-apple-pay-cta]');
  var errorContainer = form.querySelector('[data-cart-error]');
  if (!variantIdInput || !itemsJsonInput || !addToCartBtn) return;

  // Availability per variant comes from the same [data-product-json] blob
  // product-form.js reads — this file only adds a lookup by id, it never
  // duplicates the variants list.
  var productJsonEl = document.querySelector('[data-product-json]');
  var variantsById = {};
  if (productJsonEl) {
    try {
      (JSON.parse(productJsonEl.textContent).variants || []).forEach(function (v) {
        variantsById[v.id] = v;
      });
    } catch (e) {}
  }

  // Fallback safety net only: if the items-json field is ever empty/invalid
  // at submit time, assets/cart-drawer.js falls back to the plain FormData
  // flatten (id + quantity), so this hidden input must always point at a
  // real, sellable variant rather than being left blank.
  variantIdInput.value = pb.designs[0].variant_id;

  var isArabic = root.dataset.locale === 'ar';
  var propertyLabel = root.dataset.propertyLabel || 'Pack';
  var tierButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pack-tier]'));
  var rowEls = Array.prototype.slice.call(root.querySelectorAll('[data-pack-design-row]'));
  var progressFillA = root.querySelector('[data-pack-progress-a]');
  var progressFillB = root.querySelector('[data-pack-progress-b]');
  var summaryEl = root.querySelector('[data-pack-summary]');
  var summaryItemTemplate = (summaryEl && summaryEl.dataset.itemTemplate) || '%COUNT% \u00D7 %LABEL%';
  var summaryJoiner = (summaryEl && summaryEl.dataset.joiner) || ' + ';

  // Live "N pieces (breakdown)" text shown under the shared QUANTITY
  // stepper (snippets/quantity-selector.liquid, rendered by
  // sections/main-product.liquid right after this snippet) - the stepper
  // itself always counts real pieces in fixed steps of minSize (see
  // renderQuantityHint/syncForm below), this just spells that out so a raw
  // number is never mistaken for "number of packs".
  var quantityHintEl = document.querySelector('[data-pack-quantity-hint]');

  // Smallest/largest tier sizes drive every quantity rule below: the shared
  // stepper always moves in minSize steps (never a tier-dependent size),
  // and quantity > maxSize is what flips both tier buttons into "free/
  // stacked" mode. Sorted-largest-first mirrors the real Discount
  // Function's own TIERS array so decomposeQuantity fills big tiers first.
  var minSize = Math.min.apply(null, pb.tiers.map(function (t) { return t.size; }));
  var maxSize = Math.max.apply(null, pb.tiers.map(function (t) { return t.size; }));
  var sortedTiersDesc = pb.tiers.slice().sort(function (a, b) { return b.size - a.size; });

  // Fallback per-unit price for any leftover pieces decomposeQuantity can't
  // fit into a full tier — derived from the smallest tier's own price like
  // the real Function derives it from real line subtotals. Shouldn't
  // actually trigger in this UI since the shared stepper only ever moves in
  // minSize steps, but guarded rather than assumed.
  var smallestTier = pb.tiers.reduce(function (a, b) { return a.size < b.size ? a : b; });
  var basePricePerUnit = smallestTier.price / smallestTier.size;

  // counts[] now holds ABSOLUTE piece counts per design, summing to the
  // shared stepper's current displayed quantity directly (not "per one
  // pack of the selected tier") — the entire pack-multiplier concept from
  // the old tier-index model is gone.
  var counts = pb.tiers[0].default_split.slice();

  // Mirrors extensions/wet-wipes-pack-pricing's greedy TIERS decomposition
  // exactly: fill as many of the largest tier as possible, then the next,
  // etc. Returns the tiers used plus any leftover that didn't complete one.
  function decomposeQuantity(qty) {
    var remaining = qty;
    var parts = [];
    sortedTiersDesc.forEach(function (tier) {
      var count = Math.floor(remaining / tier.size);
      if (count > 0) {
        parts.push({ tier: tier, count: count });
        remaining -= count * tier.size;
      }
    });
    return { parts: parts, remainder: remaining };
  }

  // Flat total for the given quantity, decomposed the same way the real
  // Function prices the combined pack lines at checkout.
  function computeFlatTotal(qty) {
    var decomposed = decomposeQuantity(qty);
    var total = decomposed.remainder * basePricePerUnit;
    decomposed.parts.forEach(function (part) {
      total += part.count * part.tier.price;
    });
    return total;
  }

  // Largest-remainder rescale of the 2-design mix to a new total, preserving
  // the existing ratio as closely as integer counts allow (same pattern as
  // assets/cart-drawer.js's own redistribute()). With exactly 2 designs the
  // rounding remainder is always 0 or 1, so a plain loop is sufficient.
  function redistributeCounts(newTotal) {
    var oldTotal = counts[0] + counts[1];
    if (oldTotal <= 0) {
      var half = Math.floor(newTotal / 2);
      counts = [newTotal - half, half];
      return;
    }
    var raw = counts.map(function (c) { return (c / oldTotal) * newTotal; });
    var floors = raw.map(Math.floor);
    var remainder = newTotal - (floors[0] + floors[1]);
    var fracs = [0, 1].map(function (i) { return { i: i, frac: raw[i] - floors[i] }; });
    fracs.sort(function (a, b) { return b.frac - a.frac; });
    counts = floors.slice();
    for (var k = 0; k < remainder; k++) {
      counts[fracs[k % fracs.length].i] += 1;
    }
  }

  function isAvailable() {
    return pb.designs.every(function (design, i) {
      if (counts[i] <= 0) return true;
      var meta = variantsById[design.variant_id];
      return meta ? meta.available : true;
    });
  }

  // Builds the real cart line items for the current mix — never a single
  // resolved variant. Zero-count designs are omitted entirely (Shopify
  // rejects quantity: 0 items as a no-op, not an error, but there is no
  // reason to send them). The "Pack: X" property is only set when the
  // current total resolves to EXACTLY one tier with no leftover (qty === 3
  // or 6) — in free/stacked mode (9+) no single tier name applies, so the
  // property is omitted rather than guessing.
  function buildItems() {
    var decomposed = decomposeQuantity(counts[0] + counts[1]);
    var properties = {};
    if (decomposed.parts.length === 1 && decomposed.remainder === 0) {
      var tierLabel = isArabic ? decomposed.parts[0].tier.label_ar : decomposed.parts[0].tier.label_en;
      properties[propertyLabel] = tierLabel;
    }
    // Tagged onto every real cart line this pack submits so the cart drawer
    // can lock its own +/- stepper (see assets/cart-drawer.js) - the pack
    // composition (counts[]) can only be safely re-split from the PDP,
    // never from a generic per-line quantity control that has no notion of
    // the pack invariant. `_pack_locked` is underscore-prefixed (Shopify's
    // own hidden-property convention) since it's a machine flag, not
    // customer-facing copy.
    properties._pack_locked = 'true';
    var items = [];
    pb.designs.forEach(function (design, i) {
      if (counts[i] > 0) {
        items.push({ id: design.variant_id, quantity: counts[i], properties: properties });
      }
    });
    return items;
  }

  // Active/disabled tier-button state is derived PURELY from the current
  // displayed quantity every render — no persistent "selected tier" state
  // exists anymore. Both buttons go inert once quantity exceeds the
  // largest tier (free/stacked mode).
  function renderTierState() {
    var qty = window.Velo.getDisplayQuantity(form);
    var stacked = qty > maxSize;
    tierButtons.forEach(function (btn, i) {
      var tier = pb.tiers[i];
      var active = !stacked && qty === tier.size;
      btn.classList.toggle('pack-builder__tier--selected', active);
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
      btn.disabled = stacked;
    });
  }

  function renderRows() {
    rowEls.forEach(function (rowEl, i) {
      var other = 1 - i;
      var countEl = rowEl.querySelector('[data-pack-count]');
      var decBtn = rowEl.querySelector('[data-pack-decrease]');
      var incBtn = rowEl.querySelector('[data-pack-increase]');
      if (countEl) countEl.textContent = String(counts[i]);
      if (decBtn) decBtn.disabled = counts[i] <= 0;
      if (incBtn) incBtn.disabled = counts[other] <= 0;
    });

    var total = counts[0] + counts[1];
    var pctA = total > 0 ? (counts[0] / total) * 100 : 0;
    var pctB = total > 0 ? (counts[1] / total) * 100 : 0;
    if (progressFillA) progressFillA.style.width = pctA + '%';
    if (progressFillB) progressFillB.style.width = pctB + '%';
  }

  function renderSummary() {
    if (!summaryEl) return;
    var parts = [];
    pb.designs.forEach(function (design, i) {
      if (counts[i] > 0) {
        var label = isArabic ? design.label_ar : design.label_en;
        parts.push(summaryItemTemplate.replace('%COUNT%', counts[i]).replace('%LABEL%', label));
      }
    });
    summaryEl.textContent = parts.join(summaryJoiner);
  }

  // Builds the "N pieces (breakdown)" hint from the SAME decomposition used
  // for pricing/cart properties, reusing the Mix section's own
  // summary_item/summary_joiner templates (just fed tier count/label
  // instead of design count/label) — this naturally covers both the
  // single-tier case (qty 3 or 6 → one part) and the free/stacked case
  // (qty 9+ → multiple parts, e.g. "1 × Value Pack + 1 × Essential Pack")
  // with no special-casing.
  function renderQuantityHint() {
    if (!quantityHintEl) return;
    var pieces = window.Velo.getDisplayQuantity(form);
    var decomposed = decomposeQuantity(pieces);
    var unitLabel = quantityHintEl.dataset.unitLabel || '';
    var parts = decomposed.parts.map(function (part) {
      var tierLabel = isArabic ? part.tier.label_ar : part.tier.label_en;
      return summaryItemTemplate.replace('%COUNT%', part.count).replace('%LABEL%', tierLabel);
    });
    // Shouldn't normally occur (the shared stepper only ever moves in
    // minSize steps), but guarded rather than silently dropping pieces.
    if (decomposed.remainder > 0) {
      parts.push(summaryItemTemplate.replace('%COUNT%', decomposed.remainder).replace('%LABEL%', unitLabel));
    }
    var template = quantityHintEl.dataset.template || '%QTY% %UNIT% (%BREAKDOWN%)';
    quantityHintEl.textContent = template
      .replace('%QTY%', pieces)
      .replace('%UNIT%', unitLabel)
      .replace('%BREAKDOWN%', parts.join(summaryJoiner));
  }

  function syncForm() {
    var qty = window.Velo.getDisplayQuantity(form);
    var available = isAvailable();
    // PER-PIECE price derived from computeFlatTotal for THIS EXACT
    // quantity (not a fixed tier price) — VeloPricing.calculate's
    // plain_variant path (finalTotal = priceCents x displayed quantity)
    // needs a per-piece unit price to land back on the same flat total the
    // real Discount Function would charge for this quantity. packMultiplier
    // stays 1 and isSingleVariant stays 'false'. quantityStep is always the
    // SMALLEST tier size, never the "current" tier's — there is no
    // persistent tier selection anymore.
    var flatTotal = computeFlatTotal(qty);
    var priceCents = qty > 0 ? Math.round((flatTotal / qty) * 100) : 0;

    addToCartBtn.dataset.price = priceCents;
    addToCartBtn.dataset.compareAtPrice = 0;
    addToCartBtn.dataset.isSingleVariant = 'false';
    addToCartBtn.dataset.packMultiplier = 1;
    addToCartBtn.dataset.quantityStep = minSize;
    addToCartBtn.disabled = !available;
    addToCartBtn.classList.toggle('opacity-50', !available);
    addToCartBtn.classList.toggle('cursor-not-allowed', !available);

    if (applePayBtn) applePayBtn.disabled = !available;

    window.Velo.refreshAddToCartText(form);

    // The rounded per-piece price above can't always multiply back to the
    // flat total (100 / 6 → 16.67 × 6 = 100.02), so overwrite the totals
    // refreshAddToCartText just rendered with the exact flat total — the
    // same elements it writes to (button price + main [data-price], which
    // the sticky bar mirrors via MutationObserver).
    if (available && qty > 0) {
      var totalText = window.Velo.formatMoney(Math.round(flatTotal * 100));
      var buttonPriceEl = form.querySelector('[data-button-final-price]');
      var mainPriceEl = document.querySelector('[data-card-price], [data-featured-price], [data-price]');
      if (buttonPriceEl) buttonPriceEl.textContent = totalText;
      if (mainPriceEl) mainPriceEl.textContent = totalText;
    }

    renderQuantityHint();
  }

  function refresh() {
    renderTierState();
    renderRows();
    renderSummary();
    syncForm();
  }

  // Called whenever the shared QUANTITY stepper's total may have changed
  // (tier-button click or a direct +/- stepper click) — rescales the mix to
  // the new total (preserving its ratio) only when the total actually
  // moved, then re-renders everything derived from it.
  function onQuantityChanged() {
    var qty = window.Velo.getDisplayQuantity(form);
    if (counts[0] + counts[1] !== qty) {
      redistributeCounts(qty);
    }
    refresh();
  }

  tierButtons.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var tier = pb.tiers[i];
      if (window.Velo.getDisplayQuantity(form) === tier.size) return;
      window.Velo.setQuantity(form, tier.size);
      window.Velo.refreshAddToCartText(form);
      counts = tier.default_split.slice();
      refresh();
    });
  });

  rowEls.forEach(function (rowEl, i) {
    var other = 1 - i;
    var decBtn = rowEl.querySelector('[data-pack-decrease]');
    var incBtn = rowEl.querySelector('[data-pack-increase]');
    if (incBtn) {
      incBtn.addEventListener('click', function () {
        if (counts[other] <= 0) return;
        counts[other] -= 1;
        counts[i] += 1;
        refresh();
      });
    }
    if (decBtn) {
      decBtn.addEventListener('click', function () {
        if (counts[i] <= 0) return;
        counts[i] -= 1;
        counts[other] += 1;
        refresh();
      });
    }
  });

  // Writes the real multi-item cart payload right before the native form
  // submit reaches assets/cart-drawer.js's delegated (bubble-phase, on
  // document) submit listener. A listener added directly on the form itself
  // always runs first during the DOM's target phase, before the event ever
  // bubbles to document — no preventDefault/stopPropagation needed.
  form.addEventListener('submit', function () {
    itemsJsonInput.value = JSON.stringify(buildItems());
  });

  if (applePayBtn) {
    applePayBtn.addEventListener('click', function () {
      if (applePayBtn.disabled) return;
      window.Velo.checkoutSelectedVariant({
        items: buildItems(),
        button: applePayBtn,
        errorContainer: errorContainer
      });
    });
  }

  // Reacts when the shared QUANTITY stepper itself changes the value
  // (assets/quantity-selector.js's own step() calls
  // window.Velo.setQuantity/refreshAddToCartText directly, bypassing this
  // file's syncForm/refresh — those only otherwise run on a tier/mix
  // change) by rescaling the mix and re-deriving tier-button state.
  form.addEventListener('velo:quantity-changed', onQuantityChanged);

  // Initial load: default to the first tier's size (matches the markup's
  // own forloop.first pack-builder__tier--selected default), same as the
  // pre-existing behavior. counts already sums to pb.tiers[0].size via its
  // default_split, so no redistribution is needed here.
  var initialQty = pb.tiers[0].size;
  if (window.Velo.getDisplayQuantity(form) !== initialQty) {
    window.Velo.setQuantity(form, initialQty);
  }

  refresh();
})();
